/**
 * <s-offer-picker> keeps the product form's single quantity input in sync with the
 * chosen offer radio, so Add to cart and the Buy it now button both send the same quantity.
 */
class SOfferPicker extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', () => this.#sync(), { signal: this.#ac.signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const checked = this.querySelector('input[data-offer-quantity]:checked');
    const form = this.closest('form');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    if (!(checked instanceof HTMLInputElement) || !(quantityInput instanceof HTMLInputElement)) return;
    if (quantityInput.value === checked.value) return;
    quantityInput.value = checked.value;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('s-offer-picker')) customElements.define('s-offer-picker', SOfferPicker);
